<template>
  <CustomCreateDialog dialogTitle="اطلاعات حقوق و درآمد" dialogId="income-details-modal" okTitle="بستن"
    :okOnly="true"
    :isOkDisabled="isOkButtonDisabled" @ok="closeModal">
    <div class="col-12" v-if="mastersIncomeOutcomeDetail">
      <div>
        <div style="display: flex; width: 100%; flex-direction: column;">
          <p>
          جمع <span class="text-success"> درآمد ناخالص کلاس گروهی </span> فرمن:‌
          <span class="text-success">
            {{
              mastersIncomeOutcomeDetail.item.incomeGroupClass ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeGroupClass) : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="text-danger"> حقوق استاد از کلاس گروهی </span>
          فرمن:
          <span class="text-danger">
            {{
              mastersIncomeOutcomeDetail.item.outcomeGroupClass
                ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.outcomeGroupClass)
                : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="ferman-orange-text-color">
            سود کسب شده از کلاس گروهی
          </span>
          فرمن:
          <span class="ferman-orange-text-color">
            {{ Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeGroupClass-mastersIncomeOutcomeDetail.item.outcomeGroupClass) }}
          </span>
          تومان
        </p>
        </div>
        <hr>
        <div style="display: flex; width: 100%; flex-direction: column;">
          <p>
          جمع <span class="text-success"> درآمد ناخالص کار در منزل </span> فرمن:‌
          <span class="text-success">
            {{
              mastersIncomeOutcomeDetail.item.incomeHomeWork ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeHomeWork) : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="text-danger"> حقوق استاد از کار در منزل </span>
          فرمن:
          <span class="text-danger">
            {{
              mastersIncomeOutcomeDetail.item.outcomeHomeWork
                ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.outcomeHomeWork)
                : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="ferman-orange-text-color">
            سود کسب شده از کار در منزل
          </span>
          فرمن:
          <span class="ferman-orange-text-color">
            {{ Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeHomeWork-mastersIncomeOutcomeDetail.item.outcomeHomeWork) }}
          </span>
          تومان
        </p>
        </div>
        <hr>
        <div style="display: flex; width: 100%; flex-direction: column;">
          <p>
          جمع <span class="text-success"> درآمد ناخالص کلاس خصوصی </span> فرمن:‌
          <span class="text-success">
            {{
              mastersIncomeOutcomeDetail.item.incomeSchedule ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeSchedule) : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="text-danger"> حقوق استاد از کلاس خصوصی </span>
          فرمن:
          <span class="text-danger">
            {{
              mastersIncomeOutcomeDetail.item.outcomeSchedule
                ? Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.outcomeSchedule)
                : 0
            }}
          </span>
          تومان
        </p>
        <p>
          جمع
          <span class="ferman-orange-text-color">
            سود کسب شده از کلاس خصوصی
          </span>
          فرمن:
          <span class="ferman-orange-text-color">
            {{ Intl.NumberFormat("en-US").format(mastersIncomeOutcomeDetail.item.incomeSchedule-mastersIncomeOutcomeDetail.item.outcomeSchedule) }}
          </span>
          تومان
        </p>
        </div>
      </div>
    </div>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["closeModal"],
  props: {
    mastersIncomeOutcomeDetail: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,    
    };
  },
  
  methods: {
     closeModal() {
      this.$emit("closeModal")
    },

  },
  components: {
    CustomCreateDialog,
    BCol,
    BRow,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import { BCol, BRow } from "bootstrap-vue";
</script>
